module.exports = __webpack_public_path__ + "static/media/youtube-upload.e84ec564.svg";